import {
    type FC
} from "react";
import {
    Platform
} from "react-native";
import type IBreadcrumbEllipsisProps from "./type";
import {
    NCoreUIKitLocalize
} from "../../../../core/hooks";
import {
    useBreadcrumbItemContext,
    useBreadcrumbContext
} from "../../context";
import type {
    BreadcrumbHiddenItem
} from "../../type";
import {
    formatNumber
} from "../../../../helpers/locale/format";
import BreadcrumbEllipsisButton from "../ellipsisButton";
import DropdownMenu from "../../../dropdownMenu";

const BreadcrumbEllipsis: FC<IBreadcrumbEllipsisProps> = ({
    customTheme: customThemeProp,
    items: itemsProp,
    style,
    title
}) => {
    const context = useBreadcrumbContext();

    const itemContext = useBreadcrumbItemContext();

    const customTheme = customThemeProp ?? context.customTheme;

    const {
        activeLocale,
        localize
    } = NCoreUIKitLocalize.useContext(context.customLocalize);

    const items = itemsProp ?? itemContext.hiddenItems;

    if(context.isMeasure || !items.length) {
        return null;
    }

    const label = `${title ?? localize("breadcrumb-hidden-locations")} (${formatNumber({
        locale: activeLocale,
        value: items.length
    })})`;

    const handleItemPress = (item: BreadcrumbHiddenItem) => {
        if(item.onPress) {
            item.onPress();

            return;
        }

        if(Platform.OS === "web" && item.href && typeof window !== "undefined") {
            window.location.assign(item.href);
        }
    };

    return <DropdownMenu
        customLocalize={context.customLocalize}
        title={localize("breadcrumb-location")}
        customTheme={customTheme}
        side="bottom"
        align="start"
    >
        <DropdownMenu.Trigger>
            <BreadcrumbEllipsisButton
                customTheme={customTheme}
                style={style}
                title={label}
            />
        </DropdownMenu.Trigger>
        <DropdownMenu.Content>
            {items.map((item) => <DropdownMenu.Item
                onPress={() => handleItemPress(item)}
                isDisabled={item.isDisabled}
                title={item.title}
                key={item.key}
            />)}
        </DropdownMenu.Content>
    </DropdownMenu>;
};
export default BreadcrumbEllipsis;
